<template>
  <transition
      name="b-confirm-fade"
      @after-enter="afterEnter"
      @after-leave="afterLeave">
    <div class="b-confirm" @click.self="closeLayerByMask(maskClose)" v-show="visible">
      <div class="b-confirm-box" :style="[{width:layerWidth}]">
        <div class="b-confirm-btn-close" @click="close" v-if="showCloseButton"></div>
        <div class="b-confirm-box-content">
          <div class="b-confirm-image b-confirm--default" v-if="iconType === 'default'"></div>
          <div class="b-confirm-image b-confirm--info" v-if="iconType === 'info'"></div>
          <div class="b-confirm-image b-confirm--delete" v-if="iconType === 'delete'"></div>
          <div class="b-confirm-name">
            {{ title }}
          </div>
          <div class="b-confirm-tips">
            {{ tips }}
          </div>
          <slot></slot>
          <div class="b-confirm-buttons">
            <b-button type="default" class="b-confirm-button" @click="close">取消</b-button>
            <b-button type="primary" class="b-confirm-button" @click="confirm">确定</b-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import Lib from '../../../wrenches/Lib'

const ImageIcon = {
  'default': 'b-confirm--default',
  'info': 'b-confirm--info',
  'delete': 'b-confirm--delete"',
}

export default {
  name: 'BConfirm',
  data() {
    return {
      isVisible: false,
      openArg: []
    }
  },
  props: {
    iconType: {
      type: String,
      default: 'default',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '确定删除？',
    },
    tips: {
      type: String,
      default: '删除后将无法恢复，谨慎操作',
    },
    showCloseButton: {
      type: Boolean,
      default: false
    },
    maskClose: {
      type: Boolean,
      default: false,
    },
    width: [Number, String],
  },
  watch: {
    visible(nv, ov) {
      if (nv) {
        this.openLayer()
      }
    },
  },
  computed: {
    layerWidth() {
      if (Lib.isNumber(this.width)) {
        return `${this.width}px`
      } else if (Lib.isString(this.width)) {
        return this.width
      }
      return '460px'
    },
    confirmIconType() {
      return ImageIcon[this.iconType] || ImageIcon['default']
    }
  },
  methods: {
    openLayer() {
      this.$emit('open')
    },
    open(...arg) {
      this.$emit('update:visible', true)
      this.openArg = arg
      console.log('OPEN')
    },
    close() {
      // console.log('关闭')
      this.$emit('update:visible', false)
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('update:visible', false)
      this.$emit('confirm', ...this.openArg)
    },
    closeLayerByMask(isAllow) {
      if (isAllow) {
        this.close()
      }
    },
    /**
     * 动画进入
     */
    afterEnter() {
      // console.log('进入')
      this.$emit('enter')
    },
    /**
     * 动画离开
     */
    afterLeave() {
      this.$emit('leave')
    },
  },
  mounted() {
    // console.log('-------', this.visible);
  },
}
</script>
